// extracted by mini-css-extract-plugin
module.exports = {"collapseWrapper":"styles__collapseWrapper___20hOD","footer":"styles__footer___3aa06","showMore":"styles__showMore___1MzlJ"};